var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m36.553 3.33 1.856 1.856c.44.439.44 1.151 0 1.59L21.47 23.759l16.94 16.98c.44.44.44 1.152 0 1.592l-1.856 1.856c-.44.439-1.152.439-1.591 0L15.329 24.553a1.125 1.125 0 0 1 0-1.59L34.962 3.33c.44-.44 1.152-.44 1.591 0Z"
  })));
};
export default SvgChevronLeft;